import React from "react";

/**
 * QualiopiBadge — Affiche le logo Qualiopi avec la mention réglementaire obligatoire.
 *
 * Conformité :
 * - Logo officiel non modifié (déposé dans /brand/qualiopi.png — fichier fourni par
 *   l'organisme certificateur).
 * - Mention réglementaire obligatoire : "La certification qualité a été délivrée au
 *   titre de la catégorie d'action suivante : ACTIONS DE FORMATION".
 *
 * Variants :
 * - "footer"  : compact, pour le pied de page (logo + mention courte sous le logo)
 * - "block"   : grande taille, pour une page dédiée ou la page contact
 */
export default function QualiopiBadge({ variant = "footer", className = "" }) {
  const isBlock = variant === "block";

  return (
    <div
      data-testid="qualiopi-badge"
      className={`${isBlock ? "flex flex-col sm:flex-row items-center gap-5 bg-white p-5 border border-ink/10" : "inline-flex flex-col items-start gap-2"} ${className}`}
    >
      <div className={isBlock ? "shrink-0" : "bg-white rounded-sm px-3 py-2"}>
        <img
          src="/brand/qualiopi.png"
          alt="Qualiopi · Processus certifié · République Française"
          data-testid="qualiopi-logo"
          className={isBlock ? "h-20 w-auto" : "h-14 w-auto"}
        />
      </div>
      <p
        className={`text-[11px] leading-snug ${
          isBlock ? "text-ink/80" : "text-white/70 max-w-[220px]"
        }`}
      >
        La certification qualité a été délivrée au titre de la catégorie d'action suivante&nbsp;:{" "}
        <strong className={isBlock ? "text-ink" : "text-white"}>
          Actions de formation
        </strong>
        .
      </p>
    </div>
  );
}
